import Chip from 'material-ui/Chip';
import RaisedButton from 'material-ui/RaisedButton';
import DoneAllIcon from 'material-ui/svg-icons/action/done-all';
import AddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ImageIcon from 'material-ui/svg-icons/image/crop-original';
import TextField from 'material-ui/TextField';
import React from 'react';
import { connect } from "react-redux";
import {
    generateRandomLogoToken, getEntrepriseInfos,
    getPerspectives
} from "../../../../actions/entreprise/actions_entreprise_1";
import config from '../../../../config';
import AuthService from '../../../../services/AuthService';
import CustomPaper from '../../../shared/utils/CustomPaper';
import TitleMedium from "../../../shared/utils/TitleMedium";

const styles = {
    chip: {
        margin: 4,
    },
    wrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
};
class EditionGenerale extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: props.entrepriseInfos.id,
            nom: this.props.entrepriseInfos.nom,
            email: this.props.entrepriseInfos.email,
            tel: this.props.entrepriseInfos.tel,
            adresse: this.props.entrepriseInfos.adresse,
            ville: this.props.entrepriseInfos.ville,
            cp: this.props.entrepriseInfos.cp,
            siret: this.props.entrepriseInfos.siret,
            salaries_max: this.props.entrepriseInfos.salaries_max,
            salaries_ajoutes: this.props.entrepriseInfos.salaries_ajoutes,
            date_inscription: this.props.entrepriseInfos.date_inscription,
            logoRandomToken: this.props.entrepriseInfos.logoRandomToken,
            perspectives: [],
            perspective: ""
        };
        this.Auth = new AuthService();
        this.props.dispatch(getPerspectives());
        this.handleChange = this.handleChange.bind(this);
        this.handleDeletePerspective = this.handleDeletePerspective.bind(this);
        this.handleAddPerspective = this.handleAddPerspective.bind(this);
        this.handleLogoUpload = this.handleLogoUpload.bind(this);
        this.handleEditInfos = this.handleEditInfos.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!(prevState.nom) || nextProps.perspectives.length !== prevState.perspectives.length)
            return {
                ...prevState,
                id: nextProps.entrepriseInfos.id,
                nom: nextProps.entrepriseInfos.nom,
                email: nextProps.entrepriseInfos.email,
                tel: nextProps.entrepriseInfos.tel,
                adresse: nextProps.entrepriseInfos.adresse,
                ville: nextProps.entrepriseInfos.ville,
                cp: nextProps.entrepriseInfos.cp,
                siret: nextProps.entrepriseInfos.siret,
                salaries_max: nextProps.entrepriseInfos.salaries_max,
                salaries_ajoutes: nextProps.entrepriseInfos.salaries_ajoutes,
                perspectives: nextProps.perspectives,
                perspective: "",
                logo: nextProps.logo,
                date_inscription: nextProps.entrepriseInfos.date_inscription,
                logoRandomToken: nextProps.entrepriseInfos.logoRandomToken
            };
    }

    handleChange(event, value) {
        let obj = {};
        obj[event.target.name] = value;
        this.setState(obj);
    }

    handleDeletePerspective(id) {
        this.Auth.fetch("/societe/perspective/" + id, {
            method: 'delete'
        }).then(resp => {
            this.props.dispatch(getPerspectives());
        }).catch(x => {
            window.alert(x.response.data.payload);
        })
    }

    handleLogoUpload() {
        let formData = new FormData();
        let imagefile = document.querySelector('#fileToUpload');
        formData.append("fileToUpload", imagefile.files[0]);
        formData.append("user_id", this.state.id);
        this.Auth.fetch('/services/upload/logo', {}, formData)
            .then(resp => {
                this.props.dispatch(generateRandomLogoToken());
                window.alert(resp.data.payload);
            }).catch(err => window.alert(err.response.data.payload))
    }

    handleEditInfos() {
        this.Auth.fetch("/societe/infos", {
            method: 'post',
            data: this.state
        }).then(resp => {
            this.props.dispatch(getEntrepriseInfos());
            window.alert(resp.data.payload)
        }).catch(err => window.alert(err.response.data.payload.replace(/\\n/g, "\n")));
    }

    handleAddPerspective() {
        if (this.state.perspective !== "")
            this.Auth.fetch("/societe/perspectives/", {
                method: 'post',
                data: {
                    perspective: this.state.perspective
                }
            }).then(resp => {
                this.props.dispatch(getPerspectives());
            })
    }

    render() {
        const e = this.props.entrepriseInfos;
        let perspectivesChips = [];
        for (let i = 0; i < this.state.perspectives.length; i++) {
            let p = this.state.perspectives[i];
            perspectivesChips.push(<Chip
                onRequestDelete={() => this.handleDeletePerspective(p.id)}
                key={i}
                style={styles.chip} >{p.perspective}</Chip>);
        }
        return (
            <CustomPaper title={"Edition générale"}>
                <div className={"row"}>
                    <div className={"col"}>
                        <TextField
                            value={this.state.nom}
                            onChange={this.handleChange}
                            name='nom'
                            type="text"
                            floatingLabelText="Nom de l'entreprise"
                        /><br />
                        <TextField
                            value={this.state.tel !== '' ? parseInt(this.state.tel, 10) : 0}
                            onChange={this.handleChange}
                            name='tel'
                            type="number"
                            floatingLabelText="Téléphone de contact"
                        /><br />
                        <TextField
                            value={this.state.email}
                            onChange={this.handleChange}
                            name='email'
                            type="email"
                            floatingLabelText="Email de l'entreprise"
                        /><br />
                        <TextField
                            value={this.state.adresse}
                            onChange={this.handleChange}
                            name='adresse'
                            type="text"
                            floatingLabelText="Adresse"
                            multiLine={true}
                        /><br />
                        <TextField
                            value={this.state.ville}
                            onChange={this.handleChange}
                            name='ville'
                            type="text"
                            floatingLabelText="Ville"
                        /><br />
                        <TextField
                            value={this.state.cp !== '' ? parseInt(this.state.cp, 10) : 0}
                            onChange={this.handleChange}
                            name='cp'
                            type="number"
                            floatingLabelText="Code postal"
                        /><br />
                        <TextField
                            value={this.state.siret !== '' ? parseInt(this.state.siret, 10) : 0}
                            onChange={this.handleChange}
                            type="number"
                            name='siret'
                            floatingLabelText="Siret"
                        /><br /><br />
                        <RaisedButton
                            label="Modifier"
                            labelPosition="before"
                            icon={<DoneAllIcon />}
                            onClick={this.handleEditInfos}
                        />
                    </div>
                    <div className={"col"}>
                        <TitleMedium title="Logo de votre entreprise" /><br />
                        <div className='row'>
                            <div className='col'>
                                <ul style={{ fontSize: 12 }}>
                                    <li>Dimensions : (100 pixels x 70 pixels).</li>
                                    <li>Taille : 1Mo maximum.</li>
                                    <li>Format: png.</li>
                                </ul>
                                <RaisedButton
                                    label="Choisir un Logo"
                                    labelPosition="before"
                                    style={{ margin: 12, cursor: 'pointer' }}
                                    containerElement="label"
                                    icon={<ImageIcon />}
                                >
                                    <input
                                        type="file"
                                        accept="image/png"
                                        onChange={this.handleLogoUpload}
                                        onClick={e => { e.target.value = null; }}
                                        name="fileToUpload"
                                        id="fileToUpload"
                                        style={{
                                            cursor: 'pointer',
                                            position: 'absolute',
                                            top: 0,
                                            bottom: 0,
                                            right: 0,
                                            left: 0,
                                            width: '100%',
                                            opacity: 0,
                                        }}
                                    />
                                </RaisedButton>
                            </div>
                            <div className='col'>
                                {this.state.id
                                    ? <img
                                        alt='logo'
                                        id='logo-preview'
                                        style={{ height: '48px' }}
                                        src={config.upload_path + e.logo + '?randomToken=' + e.logoRandomToken} /> : null}
                            </div>
                        </div>

                        <TitleMedium title="Perspectives d'évolution de votre entreprise" /><br />
                        {this.state.perspectives.length > 0 ? <div style={styles.wrapper}>{perspectivesChips}</div> :
                            <div>
                                <div>Veuillez préciser les perspectives d'évolution de votre entreprise sur le court et le long terme.</div>
                                <details>
                                    <summary>Exemples :</summary>
                                    <p> - Basculer tous les projets en méthode Agile.</p>
                                    <p> - Créer un service de réservation en ligne.</p>
                                    <p> - Exporter nos produits en Allemagne.</p>
                                </details>
                            </div>
                        }
                        <TextField
                            value={this.state.perspective}
                            onChange={this.handleChange}
                            multiLine={true}
                            name="perspective"
                            type="text"
                            floatingLabelText="Perspectives d'évolution"
                        /><br /><br />
                        <RaisedButton
                            onClick={this.handleAddPerspective}
                            label="Ajouter"
                            labelPosition="before"
                            icon={<AddIcon />}
                        /><br />
                    </div>
                </div>

            </CustomPaper>
        );
    }
}

function mapStateToProps(store) {
    return {
        entrepriseInfos: store.entreprise.entreprise_infos,
        perspectives: store.entreprise.perspectives
    }
}

export default connect(mapStateToProps)(EditionGenerale);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entreprise/EditionGenerale.js